import {
    notificationListRequest,
    notificationItemRequest,
} from "../../../actions/notification-actions"
import buildListContainer from "../../common/build-list-container"
import NotificationsListItem from "./NotificationsListItem"
import SourceListItemShadow from "../../sources/source-list/SourceListItemShadow"

export default buildListContainer(
    NotificationsListItem,
    SourceListItemShadow,
    notificationListRequest,
    notificationItemRequest,
    "notifications"
)
